"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIntentController = void 0;
const optional_1 = require("../../types/optional");
function isIntentController(controller) {
    if (typeof controller !== "object") {
        return false;
    }
    return (0, optional_1.isSome)(controller === null || controller === void 0 ? void 0 : controller["perform"]);
}
exports.isIntentController = isIntentController;
//# sourceMappingURL=intent-controller.js.map